import HeroSection from '../HeroSection/HeroSection'
import ComingSoonAppSection from '../ComingSoonAppSection/ComingSoonAppSection'
import FeaturesSection from '../FeaturesSection/FeaturesSection'
import HowItWorks from '../HowItWorks/HowItWorks'
import AmbassadorPromoSection from '../AmbassadorPromoSection/AmbassadorPromoSection'

const Home = () => {

    return (
        <>
           {/* <Navbar/> */}
          
           <HeroSection/>
           <ComingSoonAppSection/>
           <FeaturesSection/>
           <HowItWorks/>
           <AmbassadorPromoSection/>

           
        </>
    );
};

export default Home;